import { render, staticRenderFns } from "./product_npbkcd.vue?vue&type=template&id=1c1537da&scoped=true"
import script from "./product_npbkcd.vue?vue&type=script&lang=js"
export * from "./product_npbkcd.vue?vue&type=script&lang=js"
import style0 from "./product_npbkcd.vue?vue&type=style&index=0&id=1c1537da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1537da",
  null
  
)

export default component.exports